/**
 * The one error every direct-to-store `PUT` throws on a non-2xx answer —
 * a statement, a campaign picture or form file, and a donation's evidence
 * all upload the same way (`.claude/rules/file-uploads.md`) and share this
 * rather than each declaring its own shape.
 */
export class PresignedUploadError extends Error {
  readonly status: number;

  constructor(status: number) {
    super(`The presigned upload answered ${status}`);
    this.name = 'PresignedUploadError';
    this.status = status;
  }
}
